import { render, staticRenderFns } from "./empty-default.vue?vue&type=template&id=4ed0ea46&"
import script from "./empty-default.vue?vue&type=script&lang=js&"
export * from "./empty-default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports